var dlsIconUp = {
  "&::before": {
    "content": "\"\""
  }
};

export { dlsIconUp };
